






























































import ActivityManager from "@/services/ActivityManager"
import {Component, Vue} from "vue-property-decorator"
import Activity from "@/interfaces/Activity"
import axios from 'axios'

@Component({})
export default class Home extends Vue {
    activityList: Activity[] = []

    created() {
        this.fetchData()
    }

    async fetchData() {
        try {
            this.activityList = await ActivityManager.getList()
        } catch (e) {
            console.log(e)
        }
    }

    async addActivity(activity: Activity) {
        activity.adding = true
        activity.errorsList = []
        try {
            await ActivityManager.add(activity)
            activity.added = true
        } catch (e) {
            activity.errorsList.push(e.message)
        }
        activity.adding = false
    }

    async deleteActivity(activity: Activity) {
        activity.deleting = true
        activity.errorsList = []
        try {
            await ActivityManager.delete(activity)
            activity.added = false
        } catch (e) {
            activity.errorsList.push(e.message)
        }
        activity.deleting = false
    }
}
